import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation checkAndUpdateStatusMutation(
    $input: CheckAndUpdateStatusInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    checkAndUpdateStatus(input: $input) {
      errorMessage
      successMessage
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
    }
  }
`;

const checkAndUpdateStatus = (environment, params, args = {}) => {
  const {
    integrationItemId,
    byAuth0Id,
    afterDate,
    beforeDate,
    bankAccountIdEq,
  } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: {
        integrationItemId,
      },
      beforeDate,
      afterDate,
      byAuth0Id,
      bankAccountIdEq,
    },
    ...args,
  });
};

export default checkAndUpdateStatus;
